import { ReactNode } from 'react';

// Simple timeline component. Just made it to reuse for skeleton content.
export function Timeline<T>({
  items,
  getItemKey,
  renderItemHeader,
  renderItemContent,
}: {
  items: T[];
  getItemKey: (item: T, index: number) => string | number;
  renderItemHeader?: (item: T, index: number) => ReactNode;
  renderItemContent: (item: T, index: number) => ReactNode;
}) {
  const lastItemIndex = items.length - 1;
  return (
    <ul className="grid grid-cols-[min-content_1fr] m-0 p-0">
      {items.map((item, index) => (
        <li
          key={getItemKey(item, index)}
          className="col-span-full row-span-2 grid grid-cols-subgrid grid-rows-subgrid"
        >
          <div className="row-span-2 grid grid-rows-subgrid grid-cols-[24px] justify-items-center opacity-10">
            <div
              className={[
                'h-full min-h-[16px] grid justify-items-center',
                index === 0 && index === lastItemIndex
                  ? 'grid-rows-[0_min-content_0]'
                  : index === 0
                    ? 'grid-rows-[0_min-content_1fr]'
                    : index === lastItemIndex
                      ? 'grid-rows-[1fr_min-content_0]'
                      : 'grid-rows-[1fr_min-content_1fr]',
              ].join(' ')}
            >
              <div>
                {index > 0 && <div className="w-[1px] bg-black h-full"></div>}
              </div>
              <div className="row-2 h-[8px] w-[8px] rounded-full bg-black"></div>
              <div>
                {index < lastItemIndex && (
                  <div className="w-[1px] bg-black h-full"></div>
                )}
              </div>
            </div>
            <div>
              {index < lastItemIndex && (
                <div className="w-[1px] bg-black h-full"></div>
              )}
            </div>
          </div>
          <div className="row-span-2 grid grid-rows-subgrid mb-6">
            {renderItemHeader ? (
              <>
                <header>{renderItemHeader(item, index)}</header>
                <section>{renderItemContent(item, index)}</section>
              </>
            ) : (
              <section className="row-span-2">
                {renderItemContent(item, index)}
              </section>
            )}
          </div>
        </li>
      ))}
    </ul>
  );
}
